<template>
  <b-modal id="modal-1" size="lg" hide-footer centered>
    <div class="animated fadeIn">
      <Alerts ref="alert"/>

      <Forms ref="frmGroup"
        :title="this.$lang.MechanicalWorkshop.TitleForm"
        :showHelp="true"
        :showClearButton="false"
        :showSaveButton="true"
        v-on:Clear="onClear"
        v-on:Save="onSave">
        <div class="form-group row">
          <div class="col-md-12">
          <b-tabs>
            <b-tab :title="$lang.Sinister.General.Details" active>
              <template slot="title">
                <i class="fa fa-car text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.Details }}</span>
              </template>
              <div class="form-group row">
          <div class="col-md-6">
            <label for="txtMechanicalWorkshopName"><small v-show="form.name.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelName}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtMechanicalWorkshopName"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterName"
                            v-model="form.name.value"
                            :maxlength="form.name.maxlength"
                            :required="form.name.required"
                            :state="form.name.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <label for="txtCNPJ"><small v-show="form.cnpj.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelCNPJ}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtCNPJ"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterCNPJ"
                            v-model="form.cnpj.value"
                            :maxlength="form.cnpj.maxlength"
                            :required="form.cnpj.required"
                            :state="form.cnpj.state"
                            v-mask="['##.###.###/####-##','###.###.###/####-##']"></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <label for="txtFantasyName"><small v-show="form.fantasyName.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelFantasyName}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtFantasyName"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterFantasyName"
                            v-model="form.fantasyName.value"
                            :maxlength="form.fantasyName.maxlength"
                            :required="form.fantasyName.required"
                            :state="form.fantasyName.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-6">
            <label for="txtContact"><small v-show="form.contact.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelContact}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtContact"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterContact"
                            v-model="form.contact.value"
                            :maxlength="form.contact.maxlength"
                            :required="form.contact.required"
                            :state="form.contact.state"></b-form-input>
            </div>
          </div>

        </div>
        <div class="form-group row">
          <div class="col-md-6">
            <label for="txtEmail"><small v-show="form.email.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelEmail}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtEmail"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterEmail"
                            v-model="form.email.value"
                            :maxlength="form.email.maxlength"
                            :required="form.email.required"
                            :state="form.email.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label for="txtPhone"><small v-show="form.phoneNumber.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelPhone}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtPhone"
                            :placeholder="$lang.Common.PhonePlaceholder"
                            v-model="form.phoneNumber.value"
                            :maxlength="form.phoneNumber.maxlength"
                            :required="form.phoneNumber.required"
                            :state="form.phoneNumber.state"
                            v-mask="['(##) ####-####']"></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label for="txtCellPhone"><small v-show="form.cellNumber.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelCellphone}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtCellPhone"
                            :placeholder="$lang.Common.MobilePhonePlaceholder"
                            v-model="form.cellNumber.value"
                            :maxlength="form.cellNumber.maxlength"
                            :required="form.cellNumber.required"
                            :state="form.cellNumber.state"
                            v-mask="['(##) ####-####', '(##) # ####-####']"></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12 pt-4">
            <h5 class="text-third"><i class="fa fa-pencil"></i> Observações</h5>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label for="txtDescription"> {{$lang.MechanicalWorkshop.LabelDescription}}:</label>
            <b-form-textarea
                        name="txtDescription"
                        v-model.trim="form.description.value"
                        :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterDescription"
                        :rows="form.description.rows"
                        :maxlength="form.description.maxlength"
                        :noResize="form.description.noResize"></b-form-textarea>
            <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
          </div>
        </div>

            </b-tab>
            <b-tab :title="$lang.Sinister.General.Details">
              <template slot="title">
                <i class="fa fa-wrench text-third"></i><span class="d-md-down-none pl-1 text-third"> Qualificação</span>
              </template>
              <div class="form-group row">
          <div class="col-md-6">
            <label for="cbxType"><small v-show="form.type.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelType}}:</label>
            <div class="input-group">
              <b-form-select v-model="form.type.value"
                            :options="form.type.options"
                            :state="form.type.state"
                            class="mb-3"
                            name="cbxType">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
                <option :value="0">{{$lang.Common.Undefined}}</option>
                <option :value="1">{{$lang.MechanicalWorkshop.Type.GeneralLines}}</option>
                <option :value="2">{{$lang.MechanicalWorkshop.Type.Concessionaire}}</option>
              </b-form-select>
            </div>
          </div>
          <div class="col-md-6">
            <label for="cbxCondition"><small v-show="form.condition.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelCondition}}:</label>
            <div class="input-group">
              <b-form-select v-model="form.condition.value"
                            :options="form.condition.options"
                            :state="form.condition.state"
                            class="mb-3"
                            name="cbxCondition">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
                <option :value="0">{{$lang.Common.Undefined}}</option>
                <option :value="1">{{$lang.MechanicalWorkshop.Condition.Referenced}}</option>
                <option :value="2">{{$lang.MechanicalWorkshop.Condition.NotReferenced}}</option>
              </b-form-select>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-4">
            <label for="cbxWorkByImage"><small v-show="form.workImage.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelWorkByImage}}</label>
            <div class="input-group">
              <b-form-select v-model="form.workImage.value"
                            :options="form.workImage.options"
                            :state="form.workImage.state"
                            class="mb-3"
                            name="cbxWorkByImage">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </b-form-select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="cbxSendImage"><small v-show="form.sendPhoto.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelSendImage}}</label>
            <div class="input-group">
              <b-form-select v-model="form.sendPhoto.value"
                            :options="form.sendPhoto.options"
                            :state="form.sendPhoto.state"
                            class="mb-3"
                            name="cbxSendImage">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </b-form-select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="cbxAcceptParts"><small v-show="form.acceptParts.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelAcceptParts}}</label>
            <div class="input-group">
              <b-form-select v-model="form.acceptParts.value"
                            :options="form.acceptParts.options"
                            :state="form.acceptParts.state"
                            class="mb-3"
                            name="cbxAcceptParts">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
                <option :value="true">{{$lang.Common.Yes}}</option>
                <option :value="false">{{$lang.Common.No}}</option>
              </b-form-select>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <label for="cbxWorkByImage"> {{$lang.MechanicalWorkshop.LabelReferencedInsurer}}</label>
            <div class="input-group">
              <v-select style="width: 100%"
                        multiple
                        v-model="form.insurance.value"
                        :options="getAllInsurer"/>
            </div>
          </div>
        </div>
            </b-tab>
            <b-tab :title="$lang.Sinister.General.Details">
              <template slot="title">
                <i class="fa fa-map-marker text-third"></i><span class="d-md-down-none pl-1 text-third"> Endereço</span>
              </template>
              <div class="form-group row">
          <div class="col-md-12">
            <label for="txtContact"><small v-show="form.address.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelAddress}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtContact"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterAddress"
                            v-model="form.address.value"
                            :maxlength="form.address.maxlength"
                            :required="form.address.required"
                            :state="form.address.state"></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-4">
            <label for="txtContact"><small v-show="form.addressNumber.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelAddressNumber}}:</label>
            <div class="input-group">
              <b-form-input type="number"
                            name="txtContact"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterAddressNumber"
                            v-model="form.addressNumber.value"
                            :maxlength="form.addressNumber.maxlength"
                            :required="form.addressNumber.required"
                            :state="form.addressNumber.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label for="txtContact"><small v-show="form.complement.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelAddressComplement}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtContact"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterAddressComplement"
                            v-model="form.complement.value"
                            :maxlength="form.complement.maxlength"
                            :required="form.complement.required"
                            :state="form.complement.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <label for="txtContact"><small v-show="form.district.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelAddressDistrict}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtContact"
                            :placeholder="$lang.MechanicalWorkshop.PlaceholderEnterAddressDistrict"
                            v-model="form.district.value"
                            :maxlength="form.district.maxlength"
                            :required="form.district.required"
                            :state="form.district.state"></b-form-input>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <label for="txtContact"><small v-show="form.zipcode.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelAddressZipCode}}:</label>
            <div class="input-group">
              <b-form-input type="text"
                            name="txtContact"
                            :placeholder="$lang.Common.ZipcodePlaceholder"
                            v-model="form.zipcode.value"
                            :maxlength="form.zipcode.maxlength"
                            :required="form.zipcode.required"
                            :state="form.zipcode.state"
                            v-mask="['#####-###']"></b-form-input>
            </div>
          </div>
          <div class="col-md-2">
            <label for="cbxCountry"><small class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelCoutry}}:</label>
            <div class="input-group">
              <select class="mb-3 form-control custom-select" disabled>
                <option value="2375E209-7451-4A7A-A9BE-66BD2C392BE1" selected>BRASIL</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="cbxState"><small v-show="form.stateID.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelState}}:</label>
            <div class="input-group">
              <b-form-select v-model="form.stateID.value"
                            :options="form.stateID.options"
                            :state="form.stateID.state"
                            class="mb-3"
                            name="cbxState"
                            @change="onChangeState">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
              </b-form-select>
            </div>
          </div>
          <div class="col-md-4">
            <label for="cbxCity"><small v-show="form.cityID.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelCity}}:</label>
            <div class="input-group">
              <b-form-select v-model="form.cityID.value"
                            :options="form.cityID.options"
                            :state="form.cityID.state"
                            class="mb-3"
                            name="cbxCity">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
              </b-form-select>
            </div>
          </div>
        </div>
            </b-tab>
            <b-tab :title="$lang.Sinister.General.Details">
              <template slot="title">
                <i class="fa fa-user-plus text-third"></i><span class="d-md-down-none pl-1 text-third"> Orçamentistas</span>
              </template>
              <div class="form-group row">
                <div class="col-md-12">
                  <label for="txtBudgetists"><small v-show="formBudget.nameBudget.required" class="text-danger">*</small> {{$lang.WorkshopBudget.LabelName}} </label>
                  <div class="input-group">
                    <b-form-input type="text"
                                  name="txtBudgetists"
                                  :placeholder="$lang.WorkshopBudget.PlaceholderEnterName"
                                  v-model="formBudget.nameBudget.value"
                                  :maxlength="formBudget.nameBudget.maxlength"
                                  :required="formBudget.nameBudget.required"
                                  :state="formBudget.nameBudget.state"></b-form-input>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6">
                  <label for="txtEmailBudget"> <small v-show="formBudget.emailBudget.required" class="text-danger"></small> {{$lang.WorkshopBudget.LabelEmail}}:</label>
                  <div class="input-group">
                    <b-form-input type="text"
                                  name="txtEmailBudget"
                                  :placeholder="$lang.WorkshopBudget.PlaceholderEnterEmail"
                                  v-model="formBudget.emailBudget.value"
                                  :maxlength="formBudget.emailBudget.maxlength"
                                  :required="formBudget.emailBudget.required"
                                  :state="formBudget.emailBudget.state"></b-form-input>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="txtCellPhoneBudget"><small v-show="formBudget.cellNumberBudget.required" class="text-danger">*</small> {{$lang.MechanicalWorkshop.LabelCellphone}}:</label>
                  <div class="input-group">
                    <b-form-input type="text"
                                  name="txtCellPhoneBudget"
                                  :placeholder="$lang.Common.MobilePhonePlaceholder"
                                  v-model="formBudget.cellNumberBudget.value"
                                  :maxlength="formBudget.cellNumberBudget.maxlength"
                                  :required="formBudget.cellNumberBudget.required"
                                  :state="formBudget.cellNumberBudget.state"
                                  v-mask="['(##) ####-####', '(##) # ####-####']"></b-form-input>
                  </div>
                </div>
              </div>
              <br>
              <div class="card-footer card-bottom-radius-0">
                <button type="button" class="btn btn-third btn-sm" v-on:click="onCreateBudget()" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-check-circle"></i> Adicionar</button>&nbsp;
              </div>
              <br>
                <Tables ref="tableGridBudget"
                    :columns="[$lang.WorkshopBudget.DataTable.Name,
                                $lang.WorkshopBudget.DataTable.Phone,
                                $lang.Common.DataTable.Status,
                                $lang.Common.DataTable.ActionDate,
                                $lang.Common.DataTable.AccountAction,
                                $lang.Common.DataTable.Actions]"
                    :showSearch="true"
                    :showPrint="true"
                    :showDownload="true"
                    :showFullscreen="true"
                    v-on:Load="onLoadBudget">
                  <tr v-for="obj in this.objListBudget" v-bind:key="obj.id">
                    <TableColumn :IsText="true"      :status="obj.status" :value="obj.nameBudget" classCss="text-left" />
                    <TableColumn :IsText="true"      :status="obj.status" :value="obj.cellNumberBudget"/>
                    <TableColumn :IsStatus="true"    :status="obj.status" />
                    <TableColumn :IsDatetime="true"  :status="obj.status" :value="obj.dateUpdate" />
                    <TableColumn :IsText="true"      :status="obj.status" :value="obj.accountUserNameUpdate" />
                    <TableColumn :IsActionsButtons="true" v-on:Delete="onDeleteBudget(obj)" :status="obj.status" />
                  </tr>
                </Tables>

            </b-tab>
          </b-tabs>
          </div>
        </div>
      </Forms>
      <div slot="modal-footer" class="w-100">
        <button type="button" title="" size="sm" class="float-right btn btn-default btn-sm text-secundary" @click="closeModal">
          <i class="fa fa-times-circle"></i> Fechar
        </button>
       </div>
    </div>
    </b-modal>
</template>

<script>
import MechanicalWorkshop from './mechanicalworkshop.js'

export default MechanicalWorkshop
</script>



// WEBPACK FOOTER //
// src/components/mechanicalworkshop/mechanicalworkshop.vue